/* eslint-disable func-style */
import { size } from './size';
import { each } from './each';

/**
 * Чистка объета от пустых значений
 * @param {Object} obj
 * @param {Boolean} [needFull=false] Полная чистка объекта включая null и ''
 * @returns {Object}
 */
export function cleanObject<T extends Object = {}>(obj: T, needFull?: boolean): T {
  each(obj, (val, key) => {
    if (val === undefined || (needFull && (val === null || val === ''))) {
      delete obj[key];
    } else if (typeof val === 'object' && obj !== null && !(val instanceof Date) && (!Array.isArray(val) || size(val) > 0)) {
      // @ts-expect-error recursion
      cleanObject(obj[key]);
    }
  });

  return obj;
}
